import React from 'react'
import Paper from '~/Common-Objects/UI/Paper/Paper'
export default function ThreeColPaper({
    col1Content = "",
    col2Content = "",
    col3Content = "",
    className = "",
    style = {}
}) {

    let finalClassName = "mar-b16";
    if (className) finalClassName = className;

    let finalStyle = {
        width: "100%", padding: "20px", display: "flex", flexDirection: "row", gap: "12px", justifyContent: "space-between", alignItems: "center",
        ...style
    }

    return (

        <Paper className={finalClassName} style={finalStyle}>
            <div style={{ flex: 0 }}>
                {col1Content}
            </div>
            <div style={{ flex: 1 }}>
                {col2Content}
            </div>
            <div style={{ flex: 0 }}>
                {col3Content}
            </div>
        </Paper>
    )
}